module.exports = __webpack_public_path__ + "img/机构.402a2018.jpg";